<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/profileSetting" class="vx-row">
            <feather-icon icon="ArrowLeft" svgClasses="text-dark" />
            <h3>Back</h3>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="chart-container">
      <h3>Customer Update Password</h3>
      <vs-col :lg="12">
        <vs-row>
          <vs-col :lg="5">
            <vs-input
              :type="show ? 'text' : 'password'"
              :append-icon="show ? 'visibility' : 'visibility_off'"
              @click:append="show = !show"
              required
              prepend-icon="mdi-lock"
              label="New Password"
              placeholder="Enter New Password"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="password"
              @click="togglePasswordVisibility"
              class="left-width"
            />
          </vs-col>
          <vs-col :lg="1"></vs-col>
          <vs-col :lg="5">
            <vs-input
              label="Reenter New Password"
              placeholder="Reenter Password"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="checkPassword"
              class="right-width"
            />
          </vs-col>
        </vs-row>
      </vs-col>
      <div class="matches" v-if="notSamePasswords">
        <p style="color:red">Both Passwords Not Matched</p>
      </div>

      <div class="button_content">
        <vs-button class="button2" @click="changePassword">
          Update Password
        </vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import { updatepassword } from "@/services/dashboard";
import { mapState } from "vuex";
export default {
  data() {
    return {
      show: false,
      show1: false,
      show2: false,
      show3: false,
      password: "",
      checkPassword: "",
      passwordVisible: false,
      submitted: false
    };
  },
  computed: {
    notSamePasswords() {
      if (this.passwordsFilled) {
        return this.password !== this.checkPassword;
      } else {
        return false;
      }
    },
    passwordsFilled() {
      return this.password !== "" && this.checkPassword !== "";
    },

    ...mapState("auth", {
      mobileno: state => state.mobile
    })
  },
  methods: {
    resetPasswords() {
      this.password = "";
      this.checkPassword = "";
      this.submitted = true;
      setTimeout(() => {
        this.submitted = false;
      }, 2000);
    },
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
    async changePassword() {
      try {
        if (this.passwordsFilled && !this.notSamePasswords) {
          const payload = {
            password: this.password,
            uniqueReference: JSON.parse(localStorage.getItem("in:profile"))
              .accountNo,
            userName: JSON.parse(localStorage.getItem("in:profile")).accountNo
          };
          const result = await updatepassword(payload);
          if (result) {
            (this.password = ""),
              (this.checkPassword = ""),
              this.$swal({
                group: "alert",
                type: "success",
                text: `Your Password Changed Successfully`,
                duration: 5000
              });
          }
        }
      } catch (err) {
        console.log(err);
        const message = extractError(err);
        this.$showError(message);
      }
    }
  },
  mounted() {
    this.changePassword();
  }
};
</script>

<style>
.chart-container {
  background: #fff;
  padding: 20px;
  margin: 0 1rem;
  border-radius: 20px;
}

.button_content {
  display: flex;
  justify-content: space-evenly;
}
.button2 {
  width: 200px;
  background-color: #30a852;
  font-weight: bold;
  height: 40px;
  color: #fff;
  border: 1px solid #30a852;
  border-radius: 5px;
  margin-right: 20px;
}
.right-width {
  width: 440px;
  border-radius: 4px;
}
.left-width {
  width: 430px;
  border-radius: 4px;
}
.v-select {
  width: 420px;
}
</style>
